import { Icon } from '@material-ui/core';

const Co2Icon = (props: {}) => (
  <Icon {...props}>
    <img
      src="/images/icons/car_repair.svg"
      alt="Icon for CO2 testing method"
      style={{
        width: '1em',
        height: '1em',
      }}
    />
  </Icon>
);

export default Co2Icon;
